module.exports = __webpack_public_path__ + "58a69bd42426853f64bfd7e6c8ca4620.png";